let query = {};
query.Config ={};
query.Config.mucode = {
    title:'门店代码选择',
    resources:'mall',
    method:'mss.work.report.query',
    responseCode:'mucode',
    responseName:'mucname',
    responseId:'mucode',
    response:'report',
    // width:0.5,
    searchParam:{
        queryid:'select_muid',
        order_field:'mucode'
    },
    items:[ {
        label:'编码',
        name:'mucode',
        type:'TextBox',
        sortable:true,
        condition:true
    }, {
        label:'名称',
        name:'mucname',
        type:'TextBox',
        sortable:true,
        condition:true
    }, {
        label:'城市名',
        name:'crcname',
        type:'TextBox',
        visible:false
    }]
};
query.Config.treeSignatures = {
    title:'电子签章',
    resources:'mss',
    method:'mss.work.report.query',
    responseId:'signcode',
    responseCode:'signcode',
    responseName:'signname',
    response:'report',
    idField:'signcode',
    parentField:'signpcode',
    idClass:'signclass',
    showCodeWithName:true,
    showName:true,
    showIcon:true,
    readOnly:false,
    width:0.3,
    isTree:true,
    items:[{
        label:'编码',
        name:'signcode',
        type:'TextBox',
        condition:true
    },{
        label:'编码',
        name:'signname',
        type:'TextBox',
        condition:true
    }],
    expand:true,
    showRootNode:true,
    searchParam:{
        queryid:'select_signatures'
    },
    rootNode:{
        code:'0',
        name:'电子签章'
    }
};

query.Config.ytid = {
    title:'业态',
    resources:'mall',
    method:'mss.work.report.query',
    responseCode:'code',
    responseName:'name',
    responseId:'mid',
    response:'report',
    rowAll:{code:'0', name:'全部', mid:'0'},
    searchParam:{
        queryid:'select_manacat',
        mcclass:'1',
        order_field:'code',
        order_direction:'asc'
    },
    items:[ {
        label:'编码',
        name:'code',
        type:'TextBox',
        sortable:true,
        condition:true
    }, {
        label:'名称',
        name:'name',
        type:'TextBox',
        sortable:true,
        condition:true
    } ]
};

query.Config.cat = {
    title:'品类',
    resources:'mss',
    method:'mss.work.report.query',
    responseCode:'code',
    responseName:'name',
    response:'report',
    responseId:'mid',
    rowAll:{code:'0', name:'全部', mid:'0'},
    searchParam:{
        queryid:'select_manacat',
        'mcflag':'Y',
        order_field:'code'
    },
    items:[ {
        label:'编码',
        name:'code',
        type:'TextBox',
        sortable:true,
        condition:true,
        width:150
    }, {
        label:'名称',
        name:'name',
        type:'TextBox',
        sortable:true,
        condition:true
    } ]
};

query.Config.muid = {
    title: '门店选择',
    resources: 'mall',
    method: 'mss.work.report.query',
    responseCode: 'mucode',
    responseName: 'mucname',
    responseId: 'muid',
    labelWidth: 60,
    width: 0.5,
    response: 'report',
    searchParam: {
      queryid: 'select_muid',
      order_field: 'mucode',
    },
    items: [
      {
        label: '编码',
        name: 'mucode',
        type: 'TextBox',
        sortable: true,
        condition: true,
        width: 200,
      },
      {
        label: '名称',
        name: 'mucname',
        type: 'TextBox',
        sortable: true,
        condition: true,
      },
      {
        label: '城市名',
        name: 'crcname',
        type: 'TextBox',
        visible: false,
      },
    ],
  };
export default query;





// WEBPACK FOOTER //
// ./src/method/config/queryconfig.js